/*eslint-disable*/
import BenefitsPage from 'src/modules/benefits';
import EnrollmentHistoric from 'src/modules/benefits/components/enrollment-historic';
import OpenEnrollment from 'src/modules/benefits/components/open-enrollment';
import NewHireEnrollment from 'src/modules/benefits/components/new-hire';
import QualifyingLifeEvent from 'src/modules/benefits/components/qualifying-life-event';
import UpdateEnrollmentEvent from 'src/modules/benefits/components/update-enrollment-event';
import TaxForms from 'src/modules/tax-forms';
import HelpSupport from 'src/modules/HelpSupport';
import { BenefitsReview } from 'src/modules/benefits/components/benefits-review';
import { BenefitsQleUeReview } from 'src/modules/benefits/components/benefits-qle-ue-review';
import LeavePage from 'src/modules/my-leave';
import { IRoute } from '../interfaces';
import AboutPage from '../modules/about';
import Documents from '../modules/documents';
import Dashboard from '../modules/dashboard';
import Login from '../modules/login';
import MFAPage from '../modules/mfa';
import SignUp from '../modules/sign-up';
import ManagerSignUp from '../modules/sign-up/managerSignUp';
import SetClientPassword from 'src/modules/sign-up/setClientPassword';
import PrivacyPolicy from 'src/modules/privacy-policy';
import CookiePolicy from 'src/modules/cookie-policy';
import TermsOfUse from 'src/modules/terms-of-use';
import SupportDesk from '../modules/support-desk';
import SupportDeskDetail from '../modules/support-desk/support-ticket-detail';
import createTicket from '../modules/support-desk/components';
import NotFound from '../modules/not-found';
import PasswordReset from '../modules/password-reset';
import ChangePassword from '../modules/change-password';
import PersonalInfoPage from '../modules/personal-info';
import PayHistory from '../modules/pay-history';
import Impersonation from '../modules/impersonation';
import { ReactComponent as LeaveIcon } from '../assets/Leave Application Icon.svg';
import { Permission } from './permissions';
import { ReactComponent as DashboardIcon } from '../assets/dashboard.svg';
import { ReactComponent as HrProfileIcon } from '../assets/person.svg';
import { ReactComponent as PayHistoryIcon } from '../assets/suitcase.svg';
import { ReactComponent as HelpSupportIcon } from '../assets/help-Icon.svg';
import { ReactComponent as DocumentsIcon } from '../assets/documents.svg';
import { ReactComponent as TaxFormsIcon } from '../assets/tax-forms-icon.svg';
import { ReactComponent as BenefitsIcon } from '../assets/handshake.svg';
import { ReactComponent as SupportDeskNewIcon } from '../assets/Support Ticket.svg';
import Timesheet from '../modules/timesheet';
import Expense from '../modules/expense';
import { ReactComponent as CalendarIcon } from '../assets/calendar-icon.svg';
import CreateInvoice from 'src/modules/invoice/createInvoice';
import ViewInvoice from 'src/modules/invoice/viewInvoice';
import ViewInvoiceHistory from 'src/modules/invoice/viewInvoiceHistory';
import EditInvoice from 'src/modules/invoice/editInvoice';
import InvoiceList from 'src/modules/invoice';
import { ReactComponent as InvoiceNewIcon } from '../assets/invoice.svg';
import CreateExpense from 'src/modules/expense/createExpense';
import ExpenseList from '../modules/expense';
import ViewExpense from 'src/modules/expense/viewExpense';
import EditExpense from 'src/modules/expense/editExpense';
import CompanyPolicy from 'src/modules/company-policy';

const routes: IRoute[] = [
  {
    path: '/',
    name: 'Login',
    element: Login,
    privateRoute: false,
    includeInSidebar: false,
    exact: true,
    fullScreen: false,
  },
  {
    path: '/mfa',
    name: 'MFA',
    element: MFAPage,
    privateRoute: false,
    includeInSidebar: false,
    exact: true,
    fullScreen: false,
  },
  {
    path: '/sign-up',
    name: 'Signup',
    element: SignUp,
    privateRoute: false,
    includeInSidebar: false,
    exact: true,
    fullScreen: false,
  },
  {
    path: '/sign-up-manager',
    name: 'ManagerSignUp',
    element: ManagerSignUp,
    privateRoute: false,
    includeInSidebar: false,
    exact: true,
    fullScreen: false,
  },
  {
    path: '/set-password',
    name: 'Set Password',
    element: SetClientPassword,
    privateRoute: false,
    includeInSidebar: false,
    exact: true,
    fullScreen: false,
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    element: PrivacyPolicy,
    privateRoute: false,
    includeInSidebar: false,
    exact: true,
    fullScreen: false,
  },
  {
    path: '/company-policy',
    name: 'Company Policy',
    element: CompanyPolicy,
    privateRoute: false,
    includeInSidebar: false,
    exact: true,
    fullScreen: false,
  },
  {
    path: '/cookie-policy',
    name: 'Cookie Policy',
    element: CookiePolicy,
    privateRoute: false,
    includeInSidebar: false,
    exact: true,
    fullScreen: false,
  },
  {
    path: '/terms-of-use',
    name: 'Terms of Use',
    element: TermsOfUse,
    privateRoute: false,
    includeInSidebar: false,
    exact: true,
    fullScreen: false,
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    element: Dashboard,
    privateRoute: true,
    includeInSidebar: true,
    permission: Permission.HOME,
    sidebarData: {
      path: '/dashboard',
      name: 'Dashboard',
      icon: DashboardIcon,
      backgroundColor: '#f3f4f8',
      permission: Permission.HOME,
    },
    exact: true,
    fullScreen: false,
  },
  {
    path: '/reset-password',
    name: 'Reset Password',
    element: PasswordReset,
    exact: true,
    fullScreen: false,
    privateRoute: false,
    includeInSidebar: false,
  },
  {
    path: '/create-ticket',
    name: 'create-ticket',
    element: createTicket,
    exact: true,
    fullScreen: false,
    privateRoute: true,
    permission: Permission.HOME,
    includeInSidebar: false,
  },
  {
    path: '/about',
    name: 'About Page',
    element: AboutPage,
    exact: true,
    fullScreen: false,
    privateRoute: false,
    includeInSidebar: false,
  },
  {
    path: '/Documents',
    name: 'Documents',
    element: Documents,
    exact: true,
    fullScreen: false,
    privateRoute: true,
    includeInSidebar: true,
    permission: Permission.DOCUMENTS,
    sidebarData: {
      icon: DocumentsIcon,
      path: '/Documents',
      name: 'Documents',
      backgroundColor: '#fff',
      permission: Permission.DOCUMENTS,
    },
  },
  {
    path: '/tax-forms',
    name: 'Tax Forms',
    element: TaxForms,
    exact: true,
    fullScreen: false,
    privateRoute: true,
    includeInSidebar: true,
    permission: Permission.TAX_FORMS,
    sidebarData: {
      icon: TaxFormsIcon,
      path: '/tax-forms',
      name: 'Tax Forms',
      backgroundColor: '#f3f4f8',
      permission: Permission.TAX_FORMS,
    },
  },
  {
    path: '/pay-history',
    name: 'Pay History',
    element: PayHistory,
    exact: true,
    fullScreen: false,
    privateRoute: true,
    includeInSidebar: true,
    permission: Permission.PAY_HISTORY,
    sidebarData: {
      path: '/pay-history',
      name: 'Pay History',
      icon: PayHistoryIcon,
      backgroundColor: '#f3f4f8',
      permission: Permission.PAY_HISTORY,
    },
  },
  {
    path: '/sign-up',
    name: 'Sign Up',
    element: SignUp,
    exact: true,
    fullScreen: false,
    privateRoute: false,
    includeInSidebar: false,
  },
  {
    path: '/change-password',
    name: 'Change Password Page',
    element: ChangePassword,
    exact: true,
    fullScreen: false,
    privateRoute: false,
    includeInSidebar: false,
  },
  {
    path: '/about/:id',
    name: 'About Page',
    element: AboutPage,
    exact: true,
    fullScreen: false,
    privateRoute: true,
    includeInSidebar: false,
  },
  {
    path: '/impt',
    name: 'Impersonation',
    element: Impersonation,
    exact: true,
    fullScreen: false,
    privateRoute: false,
    includeInSidebar: false,
  },
  {
    path: '/personal-information',
    name: 'HR Profile',
    element: PersonalInfoPage,
    exact: true,
    fullScreen: false,
    privateRoute: true,
    includeInSidebar: true,
    permission: Permission.HR_PROFILE,
    sidebarData: {
      icon: HrProfileIcon,
      backgroundColor: '#f3f4f8',
      permission: Permission.HR_PROFILE,
      path: '/personal-information',
      name: 'HR Profile',
    },
  },
  {
    path: '/benefits/enroll-history',
    name: 'Enrollment History',
    element: EnrollmentHistoric,
    exact: true,
    fullScreen: true,
    privateRoute: true,
    includeInSidebar: false, // disable on dev
    permission: Permission.BENEFITS,
  },
  {
    path: '/benefits/open-enrollment',
    name: 'Open Enrollment Event',
    element: OpenEnrollment,
    exact: true,
    fullScreen: true,
    privateRoute: true,
    includeInSidebar: false, // disable on dev
    permission: Permission.BENEFITS,
  },
  {
    path: '/benefits/new-hire',
    name: 'New Hire Enrollment',
    element: NewHireEnrollment,
    exact: true,
    fullScreen: true,
    privateRoute: true,
    includeInSidebar: false, // disable on dev
    permission: Permission.BENEFITS,
  },
  {
    path: '/benefits/qle',
    name: 'Qualifying Life Event',
    element: QualifyingLifeEvent,
    exact: true,
    fullScreen: true,
    privateRoute: true,
    includeInSidebar: false,
    permission: Permission.BENEFITS,
  },
  {
    path: '/benefits/ue',
    name: 'Update Enrollment',
    element: UpdateEnrollmentEvent,
    exact: true,
    fullScreen: true,
    privateRoute: true,
    includeInSidebar: false,
    permission: Permission.BENEFITS,
  },
  {
    path: '/benefits/review',
    name: 'Review Changes',
    element: BenefitsReview,
    exact: true,
    fullScreen: true,
    privateRoute: true,
    includeInSidebar: false, // disable on dev
    permission: Permission.BENEFITS,
  },
  {
    path: '/benefits/qle-review',
    name: 'Review QLE/UE Changes',
    element: BenefitsQleUeReview,
    exact: true,
    fullScreen: true,
    privateRoute: true,
    includeInSidebar: false, // disable on dev
    permission: Permission.BENEFITS,
  },
  {
    path: '/benefits',
    name: 'Benefits',
    element: BenefitsPage,
    exact: true,
    fullScreen: false,
    privateRoute: true,
    includeInSidebar: true,
    permission: Permission.BENEFITS,
    sidebarData: {
      icon: BenefitsIcon,
      backgroundColor: '#f3f4f8',
      permission: Permission.BENEFITS,
      path: '/benefits',
      name: 'Benefits',
    },
  },
  {
    path: '/my-leave',
    name: 'My Leave',
    element: LeavePage,
    exact: true,
    fullScreen: false,
    privateRoute: true,
    includeInSidebar: true,
    permission: Permission.LEAVE,
    sidebarData: {
      icon: LeaveIcon,
      backgroundColor: '#f3f4f8',
      permission: Permission.LEAVE,
      path: '/my-leave',
      name: 'My Leave',
    },
  },
  {
    path: '/help-support',
    name: 'Help Support',
    element: HelpSupport,
    exact: true,
    fullScreen: false,
    privateRoute: true,
    includeInSidebar: false,
    permission: Permission.HOME,
    sidebarData: {
      path: '/help-support',
      name: 'Help Support',
      icon: HelpSupportIcon,
      backgroundColor: '#f3f4f8',
      permission: Permission.HOME,
    },
  },
  {
    path: '/support-desk',
    name: 'SupportDesk',
    element: SupportDesk,
    privateRoute: true,
    includeInSidebar: true,
    permission: Permission.HOME,
    sidebarData: {
      path: '/support-desk',
      name: 'SupportDesk',
      icon: SupportDeskNewIcon,
      backgroundColor: '#f3f4f8',
      permission: Permission.HOME,
    },
    exact: true,
    fullScreen: false,
  },
  {
    path: '/ticket-detail/:ticketId',
    name: 'SupportDeskDetail',
    element: SupportDeskDetail,
    exact: true,
    fullScreen: false,
    privateRoute: true,
    includeInSidebar: false,
    permission: Permission.HOME,
  },
  {
    path: '/timesheet',
    name: 'Timesheet',
    element: Timesheet,
    exact: true,
    fullScreen: false,
    privateRoute: true,
    includeInSidebar: true,
    permission: Permission.HOME,
    sidebarData: {
      path: '/timesheet',
      name: 'Timesheet',
      icon: CalendarIcon,
      backgroundColor: '#f3f4f8',
      permission: Permission.HOME,
    },
  },
  {
    path: '/invoices',
    name: 'invocies',
    element: InvoiceList,
    exact: true,
    fullScreen: false,
    privateRoute: true,
    includeInSidebar: true,
    permission: Permission.INVOICE,
    sidebarData: {
      icon: InvoiceNewIcon,
      backgroundColor: '#f3f4f8',
      permission: Permission.INVOICE,
      path: '/invoices',
      name: 'Invoice',
    },
  },
  {
    path: '/invoices/create',
    name: 'createInvoice',
    element: CreateInvoice,
    exact: true,
    fullScreen: false,
    privateRoute: true,
    permission: Permission.INVOICE,
    includeInSidebar: false,
  },
  {
    path: '/invoices/:invoiceId/edit',
    name: 'editInvoice',
    element: EditInvoice,
    exact: true,
    fullScreen: false,
    privateRoute: true,
    permission: Permission.INVOICE,
    includeInSidebar: false,
  },
  {
    path: '/invoices/:invoiceId',
    name: 'viewInvoice',
    element: ViewInvoice,
    exact: true,
    fullScreen: false,
    privateRoute: true,
    permission: Permission.INVOICE,
    includeInSidebar: false,
  },
  {
    path: '/invoices/:invoiceId/history',
    name: 'viewInvoiceHistory',
    element: ViewInvoiceHistory,
    exact: true,
    fullScreen: false,
    privateRoute: true,
    permission: Permission.INVOICE,
    includeInSidebar: false,
  },
  {
    path: '/expenses',
    name: 'Expenses',
    element: ExpenseList,
    exact: true,
    fullScreen: false,
    privateRoute: true,
    includeInSidebar: true,
    permission: Permission.Expense,
    sidebarData: {
      path: '/expenses',
      name: 'Expenses',
      icon: DocumentsIcon,
      backgroundColor: '#f3f4f8',
      permission: Permission.Expense,
    },
  },
  {
    path: '/expenses/create',
    name: 'createExpense',
    element: CreateExpense,
    exact: true,
    fullScreen: false,
    privateRoute: true,
    permission: Permission.Expense,
    includeInSidebar: false,
  },
  {
    path: '/expenses/:expenseId',
    name: 'viewExpense',
    element: ViewExpense,
    exact: true,
    fullScreen: false,
    privateRoute: true,
    permission: Permission.Expense,
    includeInSidebar: false,
  },
  {
    path: '/expenses/:expenseId/edit',
    name: 'editExpense',
    element: EditExpense,
    exact: true,
    fullScreen: false,
    privateRoute: true,
    permission: Permission.Expense,
    includeInSidebar: false,
  },
  {
    path: '*',
    name: 'Not found',
    element: NotFound,
    exact: true,
    fullScreen: false,
    privateRoute: true,
    includeInSidebar: false,
  },
];

export default routes;
